<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition">
    <!--v-dialog had these props: fullscreen hide-overlay. testing without -->
    <template v-slot:activator="{ on }">
      <v-tooltip v-on="on" top>
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" fab color="secondary" v-on="on" @click="dialog=true">
            <v-icon dark>mdi-account-plus</v-icon>
          </v-btn>
        </template>
        <span>New NPC</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>New NPC</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="AddNPC()">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-form ref="NewNPC" class="pa-4">
        <v-row>
          <v-col col="12" md="5">
            <v-text-field v-model="newNPC.Name" label="Name" outlined></v-text-field>
          </v-col>
          <v-col col="12" md="3">
            <v-text-field v-model="newNPC.Age" label="Age" outlined></v-text-field>
          </v-col>
          <v-col col="12" md="3">
            <v-text-field v-model="newNPC.Race" label="Race" outlined></v-text-field>
          </v-col>
          <v-col col="12" md="1">
            <v-checkbox v-model="newNPC.Public" label="Public"></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col col="12">
            <v-textarea rows="2" v-model="newNPC.Description" label="Description" outlined></v-textarea>
          </v-col>
        </v-row>
        <Inventory :Inventory="newNPC.Inventory" />
        <v-row>
          <v-col col="12">
            <v-textarea rows="4" v-model="newNPC.Notes" label="Summary" outlined></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col col="12" md="6">
            <v-select
              v-model="TempTown"
              :items="AllTowns"
              item-text="Name"
              item-value="id"
              label="Relate to Town"
              outlined
              return-object
            ></v-select>
          </v-col>
          <v-col col="12" md="6">
            <v-text-field outlined v-model="newNPC.DndBeyondLink" label="Dnd Beyond Link"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { store } from "@/fb";
import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

import Inventory from "@/components/Inventory";

export default {
  props: ["TempTown"],
  components: { Inventory },
  data: () => ({
    // TempTown: null,
    newNPC: { Town: {}, Inventory: [] },
    dialog: false,
    AllTowns: []
  }),
  methods: {
    AddNPC() {
      this.newNPC.PlayerId = this.playerid;
      if (this.TempTown != null) {
        this.newNPC.Town.id = this.TempTown.id;
        this.newNPC.Town.Name = this.TempTown.Name;
      }

      this.newNPC.CampaignId = store.CurrentCampaign.id;

      this.newNPC.CreateDate = firebase.firestore.FieldValue.serverTimestamp();
      this.newNPC.UpdateDate = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("npcs")
        .add(this.newNPC)
        .then(docRef => {
          this.$router.push({ name: "NPC", params: { id: docRef.id } });
        });
    }
  },
  firestore() {
    this.$bind(
      "AllTowns",
      db
        .collection("towns")
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
    ).then(AllTowns => {
      AllTowns.sort(function(a, b) {
        var textA = a.Name.toUpperCase();
        var textB = b.Name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    });
  },
  created() {
    firebase.auth().onAuthStateChanged(cred => {
      this.playerid = cred.uid;
    });
  }
};
</script>
